import React from "react";

const Details = ({ rowData }) => {
    const fields = [
        { label: "Created By", key: "createdBy" },
        { label: "Created Date", key: "createdDate" },
        { label: "Start Time", key: "startTime" },
        { label: "End Time", key: "endTime" },
        { label: "ID", key: "id" },
        { label: "Kiosk ID", key: "kioskId" },
        { label: "Machine ID", key: "machinID" },
        { label: "Request Type", key: "requestType" },
        { label: "Status", key: "status" },
        { label: "Total Processing Time", key: "totalProcessingTime" },
    ];

    return (
        <div className="main-form form-details">
            <div className="p-fluid formgrid grid">
                {fields.map(({ label, key }) => (
                    <div className="field col-12 md:col-4 mb-3" key={key}>
                        <label>{label}</label>
                        <p>{rowData?.[key] ?? "N/A"}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Details;
